import { render, staticRenderFns } from "./sortingOut.vue?vue&type=template&id=1b617870&scoped=true"
import script from "./sortingOut.vue?vue&type=script&lang=js"
export * from "./sortingOut.vue?vue&type=script&lang=js"
import style0 from "./sortingOut.vue?vue&type=style&index=0&id=1b617870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b617870",
  null
  
)

export default component.exports